/**
 * Thin horizontal bar showing pass/fail/xfail/xpass/skip proportions for a CI run.
 */
export function RunSummaryBar({
  passed,
  failed,
  skipped,
  total,
  xfailed = 0,
  xpassed = 0,
}: {
  passed: number;
  failed: number;
  skipped: number;
  total: number;
  xfailed?: number;
  xpassed?: number;
}) {
  if (total === 0) return null;
  const passPercent = (passed / total) * 100;
  const failPercent = (failed / total) * 100;
  const xfailPercent = (xfailed / total) * 100;
  const xpassPercent = (xpassed / total) * 100;
  const skipPercent = (skipped / total) * 100;

  return (
    <div className="flex h-2 w-full overflow-hidden rounded-full bg-muted">
      {passPercent > 0 && (
        <div className="bg-emerald-500 transition-all" style={{ width: `${passPercent}%` }} />
      )}
      {xpassPercent > 0 && (
        <div className="bg-cyan-500 transition-all" style={{ width: `${xpassPercent}%` }} />
      )}
      {failPercent > 0 && (
        <div className="bg-rose-500 transition-all" style={{ width: `${failPercent}%` }} />
      )}
      {xfailPercent > 0 && (
        <div className="bg-yellow-500 transition-all" style={{ width: `${xfailPercent}%` }} />
      )}
      {skipPercent > 0 && (
        <div
          className="bg-muted-foreground/30 transition-all"
          style={{ width: `${skipPercent}%` }}
        />
      )}
    </div>
  );
}
